/* eslint-disable import/prefer-default-export */
import { RefObject, useEffect, useState } from 'react';

function getScrollParent(element: HTMLElement): HTMLElement | null {
  let current: HTMLElement | null = element.parentElement;
  while (current) {
    const { overflow, overflowY } = getComputedStyle(current);
    if (/(auto|scroll)/.test(overflow + overflowY)) {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}

export function useScrolledPast(
  ref: RefObject<HTMLElement>,
  resetKey?: unknown
): boolean {
  const [isScrolledPast, setIsScrolledPast] = useState(false);

  useEffect(() => {
    setIsScrolledPast(false);

    const element = ref.current;
    if (!element) return undefined;

    const scrollParent = getScrollParent(element);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsScrolledPast(false);
        } else {
          const scrollTop = scrollParent
            ? scrollParent.scrollTop
            : document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollTop > 0) {
            setIsScrolledPast(true);
          }
        }
      },
      {
        root: scrollParent,
        rootMargin: '-80px 0px 0px 0px',
        threshold: 0,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [ref, resetKey]);

  return isScrolledPast;
}
